import { render, staticRenderFns } from "./RelatorioJulgamento2024.vue?vue&type=template&id=5c85255c"
import script from "./RelatorioJulgamento2024.vue?vue&type=script&lang=js"
export * from "./RelatorioJulgamento2024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports